import React, { ReactElement, useContext } from 'react';

import ImageMessageBubble from '../../../../../mobile/scenes/channel/components/messageTypes/ImageMessageBubble';
import { ChatContext } from '../../../../../mobile/scenes/channel/types';

// @ts-ignore
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function PhotoMessage({ message, disabled }): ReactElement {
  const { handleSelectingMessage } = useContext(ChatContext);

  return (
    // @ts-ignore
    <ImageMessageBubble
      message={message}
      onLongPress={handleSelectingMessage}
      progress={message.progress}
      disabled={disabled}
    />
  );
}
